import { searchAirports } from '../../services/airportApi';
import { deduplicateAirportsModule } from './flightForm.utils';

/* Default India airport list is the same for every popup; cache it across the form lifetime
   so opening From/To never flashes "Searching airports..." after the first successful fetch.
   IMPORTANT: empty results (API failure / backend down) are never cached — otherwise the popper
   would silently stay empty forever after a single transient failure. */
export const indiaDefaultsCache = { options: null, promise: null };

export function fetchIndiaAirportDefaults() {
  if (indiaDefaultsCache.options && indiaDefaultsCache.options.length > 0) {
    return Promise.resolve(indiaDefaultsCache.options);
  }
  if (indiaDefaultsCache.promise) {
    return indiaDefaultsCache.promise;
  }
  indiaDefaultsCache.promise = searchAirports('India')
    .then((res) => {
      const options = (res.data || [])
        .map((a) => {
          if (!a.iataCode) return null;
          return {
            ...a,
            value: a.iataCode,
            label: `${a.name} (${a.iataCode}) - ${a.address?.cityName || a.cityName}, ${a.address?.countryName || a.countryName}`,
            cityName: a.address?.cityName || a.cityName,
            countryName: a.address?.countryName || a.countryName,
          };
        })
        .filter(Boolean);
      const unique = deduplicateAirportsModule(options).slice(0, 20);
      // Only cache successful, non-empty responses so a failed/empty fetch can be retried later.
      if (unique.length > 0) {
        indiaDefaultsCache.options = unique;
      } else {
        indiaDefaultsCache.options = null;
      }
      indiaDefaultsCache.promise = null;
      return unique;
    })
    .catch(() => {
      indiaDefaultsCache.promise = null;
      indiaDefaultsCache.options = null;
      return [];
    });
  return indiaDefaultsCache.promise;
}
